import api from "../services/api";

import { IRepresentante, ISearchRequest, ISearchResponse } from "../interfaces";

export interface IAgentListModel {
    id?: string;
    status: number;
    data: string;
    devedor: number;
    cpf: string;
    nome: string;
    gerenteSetor: string;
    gerenteSetorId: string;
    cidade: string;
}

interface IAgentToConferenceRequest {
    searchRequest: ISearchRequest;
    month: number;
    status: string;
}

class AgentRepository {

    public List = async (searchRequest: ISearchRequest): Promise<ISearchResponse<IAgentListModel>> => {

        const response = await api.get<ISearchResponse<IAgentListModel>>("representante", {
            params: {
                search: searchRequest.search,
                filter: searchRequest.filter,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage
            }
        });

        return response.data;

    }

    public ListToConference = async (conferenceRequest: IAgentToConferenceRequest): Promise<ISearchResponse<IAgentListModel>> => {

        const { searchRequest, month, status } = conferenceRequest;

        const response = await api.get<ISearchResponse<IAgentListModel>>(`representante/conference/month/${month}`, {
            params: {
                status: status,
                search: searchRequest.search,
                filter: searchRequest.filter,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage
            }
        });

        return response.data;
    }

    public GetById = async (id: string): Promise<IRepresentante> => {
        const response = await api.get<IRepresentante>(`representante/${id}`);

        return response.data;
    }
}

const agentRepository = new AgentRepository();
export default agentRepository;
